import { styled } from 'styled-components';

export const ShowMoreButton = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: var(--action-color);
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: var(--color-primary);
  }

  &:disabled {
    color: var(--color-disabled);
    cursor: not-allowed;
  }
`;
